<template>
  <ValidationObserver ref="observer" tag="form" @submit.prevent="submit">
    <div class="row d-flex mx-2">
      <div class="col-sm-6 py-4">
        <ValidationProvider
          tag="div"
          vid="jobTitle"
          class="mb-4"
          mode="lazy"
          rules="required"
          :customMessages="{ required: 'Norādi amata nosaukumu.' }"
          v-slot="{ errors }"
        >
          <label for="jobTitle" class="d-block text-secondary text-left mb-0"
            >Amata nosaukums</label
          >
          <input
            type="text"
            id="jobTitle"
            class="w-100 py-1 ds-input"
            v-model="jobTitle.name"
            disabled
          />
          <span class="text-danger d-block text-left small mt-1">{{
            errors[0]
          }}</span>
        </ValidationProvider>
        <ValidationProvider
          v-if="ovpJobConditionOptions.length"
          tag="div"
          vid="ovpJobConditions"
          class="mb-4"
          mode="lazy"
          :customMessages="{ required: 'Norādi kompaniju' }"
          v-slot="{ errors }"
        >
          <b-form-group label="Piesaistīt">
            <b-form-checkbox-group
              id="ovpJobConditions"
              v-model="selectedOvpJobConditions"
              :options="ovpJobConditionOptions"
              name="flavour-2a"
              stacked
            />
          </b-form-group>
          <span class="text-danger d-block text-left small mt-1">{{
            errors[0]
          }}</span>
        </ValidationProvider>
      </div>
    </div>
    <div class="row d-flex mx-2">
      <CustomButton
        class="w-25 mb-4 ds-btn--success"
        :btn-text="jobTitle._id ? 'Saglabāt izmaiņas' : 'Pievienot'"
        :is-loading="isActiveRequest"
      />
    </div>
  </ValidationObserver>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";

import CustomButton from "@/components/global/CustomButton";
import * as jobTitleStoreTypes from "../../vuex/modules/company/modules/job-titles/job-title.store-types";
import * as companyStoreTypes from "../../vuex/modules/company/company.store-types";
import * as rootStoreTypes from "../../vuex/root.store-types";
import { JobTitle } from "../../vuex/modules/company/modules/job-titles/job-title.models";

export default {
  name: "ovp-by-job-title-base-form",
  components: {
    CustomButton,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      jobTitle: { ...this.$store.state.jobTitle.selectedJobTitle },
      selectedOvpJobConditions: [],
    };
  },
  created() {
    extend("required", required);

    this.selectedOvpJobConditions = this.jobTitle.ovpJobConditions.map(
      ({ companyOvpJobCondition }) => companyOvpJobCondition
    );
  },
  computed: {
    ...mapGetters("jobTitle", {
      /** @type {boolean|*} */
      isActiveRequest: jobTitleStoreTypes.GET_IS_ACTIVE_REQUEST,
    }),
    ...mapGetters("company", {
      currentCompany: companyStoreTypes.GET_CURRENT_COMPANY,
    }),
    ovpJobConditionOptions() {
      return this.currentCompany.ovpJobConditions.map(({ _id, name }) => ({
        value: _id,
        text: name,
      }));
    },
  },
  methods: {
    ...mapMutations({
      /** @type {function|*} */
      setAlertData: rootStoreTypes.SET_ALERT_DATA,
    }),
    ...mapActions("jobTitle", {
      /** @type {function|*} */
      updateJobTitleOvpJobConditions:
        jobTitleStoreTypes.ACTION_UPDATE_JOB_TITLE_OVP_JOB_CONDITIONS,
    }),
    async submit() {
      const isValid = await this.$refs.observer.validate();

      if (!isValid) {
        return;
      }

      try {
        if (!this.jobTitle._id) {
          return;
        }

        await this.updateJobTitleOvpJobConditions({
          companyId: this.$route.params.companyId || this.currentCompany._id,
          jobTitleId: this.jobTitle._id,
          selectedOvpJobConditions: this.selectedOvpJobConditions,
        });
        this.reset();

        return this.setAlertData({
          type: "primary",
          message: "Darba apstākļi konkrētajam amatam saglabāti!",
        });
      } catch (error) {
        this.$refs.observer.setErrors({ [error.field]: [error.message] });
      }
    },
    reset() {
      this.jobTitle = new JobTitle();
      this.$refs.observer.reset();
      this.$emit("finished");
    },
  },
};
</script>